module.exports = __webpack_public_path__ + "static/NavIcon-81d79d8617c8250fe4772cbbbf954db1.png";